import { render, staticRenderFns } from "./PatientInfo.vue?vue&type=template&id=dde8f14c&scoped=true"
import script from "./PatientInfo.vue?vue&type=script&lang=js"
export * from "./PatientInfo.vue?vue&type=script&lang=js"
import style0 from "./PatientInfo.vue?vue&type=style&index=0&id=dde8f14c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde8f14c",
  null
  
)

export default component.exports